import {FC, ReactElement} from "react";
import {Navigate} from "react-router-dom";
import {Box, CircularProgress} from "@mui/material";
import usePropelAuth from "@/app2/shared/hooks/usePropelAuth";

interface IProps {
	children: ReactElement;
}

/**
 * Protects admin routes - redirects to /home if user does not have admin role.
 * Must be used within RequireAuth and App2 auth from {@link AuthProvider}.
 */
export const RequireAdmin: FC<IProps> = ({children}) => {
	const {isAdmin, loading} = usePropelAuth();

	if (loading) {
		return (
			<Box sx={{display: "flex", justifyContent: "center", alignItems: "center", height: "100vh"}}>
				<CircularProgress />
			</Box>
		);
	}

	if (!isAdmin) {
		return <Navigate to="/home" replace />;
	}

	return <>{children}</>;
};
